<template> 
  <v-card class="wz_viewListAgents">
    <v-toolbar class="accent" dark dense>
      <v-toolbar-title>{{ $t('listOfAgents') }}</v-toolbar-title>
    </v-toolbar>
<!-- liste d'agents speciale monitoring-->
    <div
      class="ContentListeAgents"
      v-bar
      v-if="routeNameMonitoring"
    >
      <v-expansion-panel
        focusable
         v-if="listeAgents.length"
      >
        <v-expansion-panel-content
          v-for="(itemAgent, i) in listeAgents"
          :key="i"
          @click.native="selectAgent(itemAgent)"
        >
          <div slot="header">
            <wz-watcheebox-agent
              :datasAgent="itemAgent"
              @loading="loading = true"
            >
            </wz-watcheebox-agent>
          </div>

            <v-list class="listeChatsAgents">
              <template v-for="(itemChat, a) in sessionsChatAgent">
                <v-list-tile ripple :class="{ 'grey lighten-5': chatSelected == itemChat[0] }" :key="a">
                  <v-icon
                    v-if="itemChat[5] == 'online'"
                    medium
                    color="light-green"
                  >
                  textsms
                  </v-icon>
                  <v-icon
                    v-else
                    medium
                    color="red"
                  >
                  mode_comment
                  </v-icon>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="$tc('visitors', 1, {count: ''})"
                      @click="updateChat(itemChat)"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="itemChat[0]"
                      @click="updateChat(itemChat)"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>

        </v-expansion-panel-content>

        <v-container v-if="loading" fill-height>
         <v-layout flex align-center justify-center>
           <v-card flat>
             <v-card-text >
               <v-progress-circular indeterminate class="primary--text" :size="100" :width="1">
               </v-progress-circular>
             </v-card-text>
           </v-card>
         </v-layout>
        </v-container>

      </v-expansion-panel>
      <div v-else class="listeAgentsEmpty">Aucun agent disponible</div>
    </div>

<!-- liste d'agents classic-->
    <div
      class="ContentListeAgentsClassic"
      v-bar
      v-else
    >
      <v-list v-if="listeAgents.length" class="listeAgents">
        <template v-for="(item, i) in listeAgents">
          <wz-watcheebox-agent
            @click.native="selectAgent(item)"
            :datasAgent="item"
            @loading="loading = true"
            :key="i"
          >
          </wz-watcheebox-agent>
        </template>
        <v-container v-if="loading" fill-height>
         <v-layout flex align-center justify-center>
           <v-card flat>
             <v-card-text >
               <v-progress-circular indeterminate class="primary--text" :size="100" :width="1">
               </v-progress-circular>
             </v-card-text>
           </v-card>
         </v-layout>
        </v-container>
      </v-list>
      <div v-else class="listeAgentsEmpty">Aucun agent disponible</div>
    </div>
    
  </v-card>
</template>

<style>
.wz_viewListAgents{height: 100% !important;}
.ContentListeAgents, .ContentListeAgentsClassic {height: calc(100% - 48px) !important; overflow-y: auto;}

.ContentListeAgentsClassic .wzSelectedAgent{background-color: rgba(0,0,0,0.1)}
.itemsListeAgent{cursor: pointer;}
.itemsListeAgent:hover{background-color: rgba(200,200,200,0.1)}
/*
.v-expansion-panel__header {padding: 0px 6px 0px 0px !important;}
.v-expansion-panel__container--active{background-color: #e5e5e5 !important;}
*/
.listeChatsAgents .v-list__tile__content {margin-left: 8px}

</style>

<script>
import { mapGetters, mapState } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js'
import _ from 'lodash'
export default {
  props: ['agentSelect', 'inMonitoring', 'visiteurSiteID'],

  data () {
    return {
      loading: false,
      visiteurData: null,
      dialogTransfereChat: false,
      selectItem: false,
      chatSelected: null,
      autorizedAgents: [],
      arrayChatSession: []
    }
  },

  methods: {
    // ----------------------------------------------------------------------------
    // Selection d'un agent
    // ----------------------------------------------------------------------------
    selectAgent (data) {
      // console.log('data', data)
      if (this.$route.fullPath === '/trafic/monitoring') {
        // commit les infos agent au parent dans tous les cas sur la page monitoring
        this.$emit('update:agentSelect', {
          'id': data[2],
          'name': data[1],
          'status': data[3],
          'socketID': data[4]
        })
      } else {
        if (this.transfertStatusEmission.status !== 'wait') {
          // commit les infos agent au parent uniquement quand je ne suis pas en attente de transfert
          this.$emit('update:agentSelect', {
            'id': data[2],
            'name': data[1],
            'status': data[3],
            'socketID': data[4]
          })
        }
      }
    },

    // ----------------------------------------------------------------------------
    // change de chat à superviser
    // ----------------------------------------------------------------------------
    updateVisSelect (visiteurID) {
      // console.log('updateVisSelect', visiteurID)
      this.oldVisSelected = this.visSelected
      this.visSelected = visiteurID
      // on connect le superviseur au nouveau chat
      _watcheebox.clientConnectRoom({'roomName': 'chat_' + visiteurID})
      // deconnect le superviseur de l'ancien chat si c'est pas le premier chat
      if (this.oldVisSelected !== null && this.oldVisSelected !== visiteurID) {
        _watcheebox.clientQuitRoom({'roomName': 'chat_' + this.oldVisSelected})
      }
    },

    // ----------------------------------------------------------------------------
    // selection du chat à afficher
    // ----------------------------------------------------------------------------
    updateChat (itemChat) {
      // console.log('itemChat', itemChat)
      this.$emit('chatSessionSelected', itemChat[0])
      this.chatSelected = itemChat[0]
    },

    // ----------------------------------------------------------------------------
    // Ferme le chat si plus de selection ou plus de session active
    // ----------------------------------------------------------------------------
    closeChat () {
      // console.log('closeChat')
      this.$emit('chatSessionSelected', 0)
      this.chatSelected = 0
    }
  },

  watch: {
    // status du transfere de chat
    'agentSelect': function (val, oldval) {
      // efface tous les class de surlignage
      for (var i = 0; i < this.agentsArray.length; i++) {
        if (document.getElementById('agent_' + this.agentsArray[i][2])) {
          document.getElementById('agent_' + this.agentsArray[i][2]).classList.remove('wzSelectedAgent')
        }
      }
      // et surligne uniquement le selectionné
      if (document.getElementById('agent_' + this.agentSelect.id)) {
        document.getElementById('agent_' + this.agentSelect.id).classList.add('wzSelectedAgent')
      }
    },

    'arrayChatSession': function (val, oldval) {
      // console.log('val', val)
      if (this.chatSelected) {
        let chackListChat = _.findIndex(val, [0, this.chatSelected])
        if (chackListChat === -1) {
          // il faut effacer le chat actif si plus de session avec le visiteur
          console.log('ce chat est plus dispo')
          this.closeChat()
        }
      }
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['agentsArray', 'transfertStatusEmission', 'listeChatAgent', 'listeAllVisiteurs']),
    ...mapGetters('_User', ['user', 'fullName']), // mes infos agent
    ...mapGetters('_Sites', ['AUTORIZED_AGENTS']),

    listeAgents () {
      if (!this.inMonitoring) {
      // on filtre les agents
        return this.AUTORIZED_AGENTS({
          agentsArray: this.agentsArray,
          siteID: this.visiteurSiteID,
          myID: this.user.id
        })
      } else {
        // affiche tous les agents
        return this.agentsArray.filter(agent => agent[2] !== this.user.id)
      }
    },

    sessionsChatAgent () {
      this.arrayChatSession = _.cloneDeep(_.filter(this.listeChatAgent, [3, this.agentSelect.id]))
      // let chatSelection = 0
      _.forEach(this.arrayChatSession, (chatSession, key) => {
        let index = _.findIndex(this.listeAllVisiteurs, {'visiteurID': chatSession[0]})
        if (index === -1) {
          this.arrayChatSession[key].push('offline notInList')
        } else {
          if (this.listeAllVisiteurs[index].socketID) {
            this.arrayChatSession[key].push('online')
          } else {
            this.arrayChatSession[key].push('offline')
          }
        }
      })
      // console.log('chatSelection', chatSelection)
      // console.log('arrayChatSession', arrayChatSession)
      return this.arrayChatSession
    },

    routeNameMonitoring () {
      if (this.$route.fullPath === '/trafic/monitoring') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
 



// WEBPACK FOOTER //
// src/components/watcheebox/WzListAgents.vue